import React from 'react';
import {
  Container
} from 'reactstrap';

// Import background images
import upcomingEventBg from '../assets/images/upcoming-event-bg.png';
import partnerWithUsBg from '../assets/images/partner-with-us.png';

// Export background images for use in other components
export { upcomingEventBg, partnerWithUsBg };

const BreadCrumb = ({ 
  title, 
  description, 
  backgroundImage = upcomingEventBg, // Default to upcoming event background
  backgroundClass = "event-hero-section",
  titleClass = "past-event-title",
  descriptionClass = "past-event-desc"
}) => {
  const sectionStyle = {
    background: `url(${backgroundImage}) center/cover no-repeat, black`,
    minHeight: '70vh',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  return (
    <section className={`${backgroundClass} text-center`} style={sectionStyle}>
      <Container>
        <div className="event-bg-overlay"></div>
        <div className="upcoming-event-banner text-center position-relative">
          <h1 className={titleClass}>{title}</h1>
          {description && (
            <p className={descriptionClass}>{description}</p>
          )}
        </div>
      </Container>
    </section>
  );
};

export default BreadCrumb;
